import React, { useEffect, useState, useRef } from 'react';
import { Link, useHistory } from 'react-router-dom';
import Cookies from 'js-cookie'
import { Dropdown, Form, ListGroup, CloseButton, Spinner } from 'react-bootstrap';
//images
// import { AutoCompleteComponent } from '@syncfusion/ej2-react-dropdowns';
// import TextField from '@material-ui/core/TextField';
// import Autocomplete from '@material-ui/lab/Autocomplete';
import logo from './../assets/images/companyresource/logo_bvs.jpg';
import listnoimage from './../assets/images/Resources/Listno-image.jpg';
import noimage from "./../assets/images/Resources/no-image.jpg";
import profile from './../assets/images/ProfileImages/guest.png';
import Collapse from 'react-bootstrap/Collapse';
import { MenuListArray2 } from './MenuListArray2';
import { GetUserCartandWishlistCount, GetMasterTitleCategorySubCategory, GetSearchListOnDemand, GetUserDetail, GetWebGetUserCart, WebDeleteUserCartandItem } from '../components/APISCollection';
import "../assets/css/order.css";
import { DotLoader } from 'react-spinners';
import { Toaster } from 'react-hot-toast';
import Marquee from "../pages/Marque";


const Categorydata = [ 
	// {FilterName: "Description"}, 
	{FilterName: "Search ALL"},
	{ FilterName: "Categories"},
	{ FilterName: "Title"},	
	{FilterName: "Author"}, 
	
];




function Header() {	
	const timeNow = new Date().toLocaleString();
	const [CartCount,setCartCount] = useState(0);
	var LocalCurrency = sessionStorage.getItem("LocalCurrency");
    const SaleCurrency = ((LocalCurrency === undefined || LocalCurrency === null || LocalCurrency === "")?"₹":LocalCurrency);
	const history = useHistory();
	const str_UserID = sessionStorage.getItem("USERID");
	const [Userdata, setUserdata] = useState([])
	const [inFocus, setInfocus] = useState(false);
	const [selectBtn, setSelectBtn] = useState('Search ALL');
	const [CartClicked, setCartClicked] = useState(false);
	/* for sticky header */
	const [headerFix, setheaderFix] = React.useState(false);
	const [CartLoaded, setCartLoaded] = useState(false);
	const [SecondHeaderCart, setSecondHeaderCart] = useState([]);
	/* for open menu Toggle btn  */
	const [sidebarOpen, setSidebarOpen] = useState(false);
	const showSidebar = () => setSidebarOpen(!sidebarOpen);
	/*  Toggle btn End  */
	var strCategoryID = "", action = 0;
	
	var websearchtype = "ALL", websearchText = "",websearchTextM = "", Searchsubjectlist = "", SearchsubjectlistID = "", PageNum = 1, PageSize = 10;
	var userID = Cookies.get('UserID');
	const User = (userID == "guest" ? "guest" : userID);
	const UName = Cookies.get('UserID');
	const [showUser, setShowUser] = useState([]);
    var LoadCount=0;
	var LoadCountWish=0;
	var count=0;
	var load = document.getElementById("txtSearch");
	// Menu dropdown list
	const [active, setActive] = useState('Home')
	const handleMenuActive = status => {
		setActive(status)
		if (active === status) {
			setActive('');
		}
	}
	useEffect(() => { 

		
		
			window.addEventListener("scroll", () => {
				setheaderFix(window.scrollY > 50);
				if (document.getElementById('spnIDOnScroll')!=undefined)
				{
					document.getElementById('spnIDOnScroll').innerHTML=document.getElementById('TopCartOne').innerHTML;
				}
				if (document.getElementById('secondWish')!=undefined)
				{
					document.getElementById('secondWish').innerHTML=document.getElementById('TopWishtOne').innerHTML;
				}

			//	document.getElementById('spnIDOnScroll').innerHTML=+LoadCount ;	
			}); 
		var mainMenu = document.getElementById('OpenMenu');
			if (mainMenu) {
				if (sidebarOpen) {
					mainMenu.classList.add('show');
					
				} else {
					mainMenu.classList.remove('show');
				}
			}

		
			if (User==="guest"){
				var guestCart = Cookies.get("_guestUserCart");
				var temp = JSON.parse(guestCart); 
				if (temp!=undefined)
				{ LoadCount = temp.length
				if (temp.length===1 && temp[0].Item_ID==="")
				{
					LoadCount=0;
				}
				}
				// if(temp.length ===1){
				// LoadCount = 0}
				 	document.getElementById('TopCartOne').innerHTML=+LoadCount ;
					 if (document.getElementById('TopCartFive')!=undefined)
					 {
						 document.getElementById('TopCartFive').innerHTML=document.getElementById('TopCartOne').innerHTML;
					 }
					 document.getElementById('TopCartOne').innerHTML=+LoadCount ;
              
				// document.getElementById('spnIDOnScroll').innerHTML=+LoadCount ;	
			}


			else
			{
			GetUserCartandWishlistCount(User).then(result => {
				setUserdata(result.data);
				if (result.data.length>0)
					{
						if (result.data[0].Result === "Failed") {
					
							
						} else {
							LoadCount=result.data[0].CartItemCount;		
							LoadCountWish=result.data[0].wishListCount;		
							
							document.getElementById('TopCartOne').innerHTML=+LoadCount ;
							
						//	document.getElementById('spnIDOnScroll').innerHTML=+LoadCount ;	
                     	
							
							 document.getElementById('TopWishtOne').innerHTML=+LoadCountWish ;
						//	document.getElementById('secondWish').innerHTML=+LoadCountWish ;	
						} 
					}
					if (document.getElementById('TopCartFour')!=undefined)
					{
						document.getElementById('TopCartFour').innerHTML=document.getElementById('TopCartOne').innerHTML;
					}


					
					if (document.getElementById('Wishmob')!=undefined)
					{
						document.getElementById('Wishmob').innerHTML=document.getElementById('TopWishtOne').innerHTML;
					}
			
				//CartItemCount
			});

		}
	
	    
		// GetMasterTitleCategorySubCategory(strCategoryID, action).then(result => {
		// 	setCategorydata(result.data);
		// 	localStorage.setItem("Category", JSON.stringify(result.data));
		// 	// console.log(result.data);  
		// })

		if (User == "" || User == "guest" || User == null || User == undefined) {
			var guestCart = Cookies.get("_guestUserCart");
			var ItemCount = 0;
			if(guestCart==="" || guestCart===null|| guestCart===undefined){
				guestCart = "";
			}
			if(guestCart !=="" ||guestCart !==undefined ||guestCart !==null || guestCart !=="[]" || guestCart.length!==0 ){
				var temp = JSON.parse(guestCart);
				if(temp.length !== 0){ 
				var ItemCount = temp.length;
				if(temp[0].Item_ID === ""){
					ItemCount = 0;
				}
				setCartCount(ItemCount);
			}else{
               
				setCartCount(ItemCount);
			}}else{
				Cookies.remove("_guestUserCart");
			}
			
		} else { 
			GetUserDetail(User).then(result => {
				setShowUser(result.data);
				 sessionStorage.setItem("schlID",result.data[0].SchoolCode);
			});
		} 
		GetWebGetUserCart(User, 'INDIA').then(result => {
			if (result.data[0].Result === "Failed") {
			
				// setCartCount(0); 
				setCartLoaded(false);

				// var spn = document.getElementById("spinner")
				// document.getElementById("spinner").style.display="none";
				// if(document.getElementById("dv_CartList") !== null){
				// 	document.getElementById("dv_CartList").style.display = "none";
				// 	document.getElementById("dv_EmptyBlock").style.display = "block";
				// } 
			} else {

				setCartLoaded(true);
				Cookies.set('shpcst', (result.data[0].ShipCost));
				// setCartCount(result.data.length);  
			} 
		});
	}, []);



	//Menu dropdown list End
	//const history = useHistory();
	//const auth = localStorage.getItem("SessionID");
 

	function Loader(){
		return(
			<>
			 <div style={{display:'block' , textAlign:'center'}}>
			<span id="spinner" ><Spinner animation='border' loading = {loading}/></span>
			 <br/>
			 <span className="text-secondary" id="spinnerText"style={{display:'none'}} >Your Cart is Empty, Please add item into your cart.</span> </div>
			</>
		)
	}
	function userLogOut() {
		var Rememberme = Cookies.get('Rememberme');
		if (Rememberme == "false") { Cookies.remove('Email'); Cookies.remove('UserCreds'); Cookies.remove('Rememberme'); }
		Cookies.remove('UserID'); Cookies.remove('Name'); Cookies.remove('Pwd'); Cookies.remove('Mobile'); 
		Cookies.remove('CityCode'); Cookies.remove('Address'); Cookies.remove('CartCode');
		Cookies.remove("_guestUserCart");
		const UserID =  Cookies.get('UserID');
		if(UserID === ""|| UserID === null || UserID === undefined ){
			Cookies.set('UserID', "guest");
		}  

		if(UserID === "guest"){
			var tmpGuestCart = Cookies.get("_guestUserCart");
			if(tmpGuestCart === "" || tmpGuestCart === null || tmpGuestCart === undefined){
				const current = new Date();
				const nextYear = new Date();
				nextYear.setFullYear(current.getFullYear() + 1);
	
				var temp = [{ SlNo: 1, Item_ID: "", Item_QTY: 0 }];
				temp = JSON.stringify(temp);
				Cookies.set("_guestUserCart", temp, { path: "/", expires:nextYear }); 
			}
		} 

	//	alert("log out successfully");
		history.push('shop-login');
		//window.location.href = "shop-login";
		window.location.reload(); 
	}
	var CategoryID = "", SiteName = "BookStore", SchoolCode = "";
	const [mySearchList, setmySearchList] = useState([]);
	const [mySearchList1, setmySearchList1] = useState([]);
	const [searching, setSearching] = useState();

  var websearchtypeM ='';
   const  handlerM= async ( event)=>{
	websearchtypeM = selectBtn.toUpperCase();
	//	alert(websearchtype);
		if (websearchtype==="ISBN") {websearchtype="BYISBN";}
		if (websearchtype==="TITLE") {websearchtype="BYTitle";}
		if (websearchtype==="AUTHOR") {websearchtype="ByAuthor";}
		if (websearchtype==="CATEGORIES") {websearchtype="ByCATEGORIES";}
	//	alert(websearchtype);
	
	
//alert(websearchtype)
let inpValueM = document.getElementById("txtSearchMobile");

websearchTextM = inpValueM.value;


if (event == "" || event == null || event == undefined) {
	setSearching(inpValueM.value);
	window.location.href = "book-shop-search?q=" + websearchTextM;
} else {
	if (event.key == 'Enter') {
		window.location.href = "book-shop-search?q=" + websearchTextM;
		// history.push("/book-shop-search?q=" + websearchText);
		// let MainDivision = document.getElementById("dv_SearchList");
		// MainDivision.style.display = "none";
		
	} 
}


if (event == "" || event == null || event == undefined) {
	setSearching(inpValueM.value);
	window.location.href = "book-shop-search?q=" + websearchTextM;
} else {
	if (event.key == 'Enter') {
		window.location.href = "book-shop-search?q=" + websearchTextM;
		// history.push("/book-shop-search?q=" + websearchText);
		// let MainDivision = document.getElementById("dv_SearchList");
		// MainDivision.style.display = "none";
		 
	} else {

		websearchTextM = event.target.value.toLowerCase();
		GetSearchListOnDemand(websearchtype, websearchTextM, CategoryID, SiteName, SchoolCode, PageNum, PageSize).then(result => {
			setmySearchList1(result.data);
			
		
			if (result.data[0].Result == "Failed") {
				let inpValue = document.getElementById("dv_SearchList");
				inpValue.style.display = "none"
				setmySearchList1([]);
			} else {
				let inpValue = document.getElementById("dv_SearchList");
				inpValue.style.display = "block"
				setSearching(true);
			}
			//console.log(result.data);
			if (websearchText == "") {
				setmySearchList1([]);
			}  
		});
	}
}
	
   }


	const handler = async (event) => {  
		websearchtype = selectBtn.toUpperCase();
	//	alert(websearchtype);
		if (websearchtype==="ISBN") {websearchtype="BYISBN";}
		if (websearchtype==="TITLE") {websearchtype="BYTitle";}
		if (websearchtype==="AUTHOR") {websearchtype="ByAuthor";}
		if (websearchtype==="CATEGORIES") {websearchtype="ByCATEGORIES";}
	//	alert(websearchtype);
	
	
//alert(websearchtype)

		let inpValue = document.getElementById("txtSearch");
		websearchText = inpValue.value;

		if (event == "" || event == null || event == undefined) {
			setSearching(inpValue.value);
			window.location.href = "book-shop-search?q=" + websearchText;
		} else {
			if (event.key == 'Enter') {
				window.location.href = "book-shop-search?q=" + websearchText;
				// history.push("/book-shop-search?q=" + websearchText);
				// let MainDivision = document.getElementById("dv_SearchList");
				// MainDivision.style.display = "none";
				
			} else {

				websearchText = event.target.value.toLowerCase();
				GetSearchListOnDemand(websearchtype, websearchText, CategoryID, SiteName, SchoolCode, PageNum, PageSize).then(result => {
					setmySearchList(result.data);
					console.log(result.data)
					if (result.data[0].Result == "Failed") {
						let inpValue = document.getElementById("dv_SearchList");
						inpValue.style.display = "none"
						setmySearchList([]);
					} else {
						let inpValue = document.getElementById("dv_SearchList");
						inpValue.style.display = "block"
						setSearching(true);
					}
					//console.log(result.data);
					if (websearchText == "") {
						setmySearchList([]);
					}  
				});
			}
		}
	};
	var TotNetAmount = 0;
	var TotSaleCurrency = "";
	var total = 0;

	var totalamt =0;
	var TtNetAmount =0;

	var toalamt =0;
	var TNetAmount =0;

	var totalamt =0;
	var TtNetAmount =0;
	// var dIndex = "";

	const [headerCart1, setHeaderCart1] = useState([]);
	const [headerCart2, setHeaderCart2] = useState([]);
	const [headerCart3, setHeaderCart3] = useState([]);
	const [headerCart4, setHeaderCart4] = useState([]);

	// const [count, setCount] = useState([]);
	const [loading , setLoading] = useState(true);
	function headeCartShow() {
		var guestCart = Cookies.get("_guestUserCart");
		if(guestCart === "" || guestCart === null || guestCart === undefined){
			guestCart = "";
		} 
		var temp = "";
		if(guestCart !== ""){
			var temp = JSON.parse(guestCart);  
		}
		if(guestCart !== ""){
			var temp = JSON.parse(guestCart);  
		}
		
		GetWebGetUserCart(User, 'INDIA', temp).then(result => {
			if (result.data[0].Result === "Failed") {
				
				setCartLoaded(false);
				setHeaderCart1([]);
				setHeaderCart2([]);
				setHeaderCart3([]);
				setHeaderCart4([]);
				document.getElementById("spinner").style.display="none";
				document.getElementById("spinnerText").style.display="block";
				// if(document.getElementById("dv_CartList") !== null){
				// 	document.getElementById("dv_CartList").style.display = "none";
				// 	document.getElementById("dv_EmptyBlock").style.display = "block";
				// } 
			//  setCartCount(0);
			} else {
				setHeaderCart1(result.data);
				setHeaderCart2(result.data);
				setHeaderCart3(result.data);
				setHeaderCart4(result.data);
				//setHeaderCart(result.data);
				//setCartCount(result.data.length);
				setCartLoaded(true);
				setLoading(false)
				// setCartCount(result.data.length);
				console.log(result.data);
					
			// document.getElementById("dv_CartList").style.display = "block";
			// document.getElementById("dv_EmptyBlock").style.display = "none";
			/* not in use 
			// if(document.getElementById("dv_CartList") !== null){
				// 	document.getElementById("dv_CartList").style.display = "block";
				// 	document.getElementById("dv_EmptyBlock").style.display = "none";
				// } 
			*/	
			}

			//console.log(result.data);
		}).catch(error => {console.log(error);});
		
	}
	 
	
	const handleChange = (event) => {
		var Actiontype = "ALL", firstValue = "", secondValue = ""; CategoryID = event.toLowerCase();
		GetSearchListOnDemand(websearchtype, websearchText, CategoryID, SiteName, SchoolCode, PageNum, PageSize).then(result => {
			if (websearchText == "") {
				setmySearchList([]);
			} else {
				setmySearchList(result.data);
				console.log(result.data)
			}			
			//console.log(result.data);
		});
	}

	let useClickOutside = (handler) => {
		let closeMenu = useRef();
		useEffect(() => {
			let handlerEvent = (event) => {
				if (!closeMenu.current.contains(event.target)) {handler();};
			};
			document.addEventListener("mousedown", handlerEvent); 
			return () => {document.removeEventListener("mousedown", handlerEvent);};
		});
		return closeMenu
	};
	let closeMenu = useClickOutside(() => {
		//setSidebarOpen(true);
	});

	function Hidetoggel (){
		var mainMenu = document.getElementById('OpenMenu');
		alert(mainMenu.classList)
		mainMenu.classList.remove('show');
	}


	return ( 
		<header className="site-header mo-left header style-1">
    
	{/* <div className="container topHeader">
		<div >
		<a href="contact-us" ><span style={{fontSize:"16px", color:"#F76D01",fontWeight:"500"}} >Click here for Bulk Order or if you cannot find any book on our website</span></a>   
		</div>
		<div className="topHeader1">
        <div style={{fontSize:"16px", color:"#F76D01", padding:"1px", fontWeight:"500"}}>{timeNow} </div>
		<div className="animate__animated animate__heartBeat ">  <span className="btntop ">Subscriptions</span></div>
		</div>
				
			</div>  */}
			<div className="header-info-bar">
				<div className="container clearfix" style={{paddingright:""}}>
					{/* <!-- Website Logo --> */}
					<div className="logo-header logo-dark">
						<Link to={""}>
							<img src={logo} alt="Education World" />
						</Link>
					</div>

					{/* <!-- EXTRA NAV --> */}
					<div className="extra-nav">
						<div className="extra-cell">
							<ul className="navbar-nav header-right">
								{User !== "guest" ? <>
									<li className="nav-item">
										<Link to={"wishlist"} className="nav-link">
											<svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000"><path d="M0 0h24v24H0V0z" fill="none" /><path d="M16.5 3c-1.74 0-3.41.81-4.5 2.09C10.91 3.81 9.24 3 7.5 3 4.42 3 2 5.42 2 8.5c0 3.78 3.4 6.86 8.55 11.54L12 21.35l1.45-1.32C18.6 15.36 22 12.28 22 8.5 22 5.42 19.58 3 16.5 3zm-4.4 15.55l-.1.1-.1-.1C7.14 14.24 4 11.39 4 8.5 4 6.5 5.5 5 7.5 5c1.54 0 3.04.99 3.57 2.36h1.87C13.46 5.99 14.96 5 16.5 5c2 0 3.5 1.5 3.5 3.5 0 2.89-3.14 5.74-7.9 10.05z" /></svg>
											<span className="badge" id ='TopWishtOne'>{LoadCountWish}</span>
										</Link>
									</li>
									<Dropdown as="li" className="nav-item" onClick={headeCartShow} >
										<Dropdown.Toggle as="button" type="button" className="nav-link box cart-btn i-false" >
											<svg xmlns="http://www.w3.org/2000/svg"  height="24px" viewBox="0 0 24 24" width="24px" fill="#000000">
												<path d="M0 0h24v24H0V0z" fill="none" />
												<path d="M15.55 13c.75 0 1.41-.41 1.75-1.03l3.58-6.49c.37-.66-.11-1.48-.87-1.48H5.21l-.94-2H1v2h2l3.6 7.59-1.35 2.44C4.52 15.37 5.48 17 7 17h12v-2H7l1.1-2h7.45zM6.16 6h12.15l-2.76 5H8.53L6.16 6zM7 18c-1.1 0-1.99.9-1.99 2S5.9 22 7 22s2-.9 2-2-.9-2-2-2zm10 0c-1.1 0-1.99.9-1.99 2s.89 2 1.99 2 2-.9 2-2-.9-2-2-2z" />
											</svg>
											<span className="badge"  id="TopCartOne">{LoadCount}</span>
											{/* {count} */}
										</Dropdown.Toggle>
										<Dropdown.Menu as="ul" className={`dropdown-menu cart-list ${CartLoaded ? '' : 'displayB'}`} id="drp_CartList">
										{loading ? <> <Loader/>
										 </>:<>
											{headerCart1.map((data, index) =>{ TotNetAmount = TotNetAmount+ (data.ItemDiscountedPrice * data.Qty);  TotSaleCurrency = data.SaleCurrency;  total = data.ItemDiscountedPrice * data.Qty;
												// dIndex = index+1;
												return (
												
														
														<div key={index}>
														<li className="cart-item">
															<div className="media">
																{data.isEBook !==1?<>
																<div className="media-left">
																	<Link to={"product-detail?q=" + data.ProductID}  >
																		<img alt={data.BookName} className="media-object" src={data.ProductImage} onError={(e) => e.target.src = noimage} />
																	</Link>
																</div>
																<div className="media-body" >
																	<h6 style={{ cursor: "pointer" }}>
																		<Link to={"product-detail?q=" + data.ProductID}  style={{ fontSize: '12px' }}>{data.BookName}</Link></h6>
																	<span className="dz-price">
																		
																			
																				<del className="cutPriceFont" >{SaleCurrency} {data.Price}</del>
																				<span className="priceCSS" > &nbsp;{SaleCurrency} {data.ItemDiscountedPrice}*{data.Qty} = {SaleCurrency} {total.toLocaleString('en-IN')}</span>
																			
																		{/* {SaleCurrency} {data.Price}*{data.Qty} = {SaleCurrency} {total} */}
																	</span>
																</div></>:<>
																<div className="media-left">
																<Link to={"product-detail?q=" + data.ProductID}  >
																	<img alt={data.BookName} className="media-object" src={data.ProductImage} onError={(e) => e.target.src = noimage} />
																</Link>
															</div>
															<div className="media-body" >
																<h6 style={{ cursor: "pointer" }}>
																	<Link to={"product-detail?q=" + data.ProductID}  style={{ fontSize: '12px' }}>{data.BookName}</Link></h6>
																<span className="dz-price">
																	
																		
																			<del className="cutPriceFont" >{SaleCurrency} {data.Price}</del>
																			<span className="priceCSS" > &nbsp;{SaleCurrency} {data.ItemDiscountedPrice}*{data.Qty} = {SaleCurrency} {total.toLocaleString('en-IN')}</span>
																		
																	{/* {SaleCurrency} {data.Price}*{data.Qty} = {SaleCurrency} {total} */}
																</span>
															</div>
																</>}
															</div>
														</li>

													</div>
													
													)
											})}	
											<div id="dv_CartList" className={`${CartLoaded ? '' : 'displayB'}`}>
												<li className="cart-item text-center">
													<h6 className="text-secondary">Total = {SaleCurrency} {TotNetAmount.toLocaleString('en-IN')}</h6>
												</li>
												<li className="text-center d-flex">
													<Link to={"shop-cart"} target="_parent"  className="btn btn-sm btn-primary me-2 btnhover w-100">View Cart</Link>
													<Link to={"shop-checkout"} target="_parent"  className="btn btn-sm btn-outline-primary btnhover w-100">Checkout</Link>
												</li>
											</div>
											<div id="dv_EmptyBlock"  className={`displayB ${CartLoaded ? '' : 'showheadEmptrycart'}`} >
												<li className="cart-item text-center">
													<span className="text-secondary">Your Cart is Empty, Please add item into your cart.</span>
												</li>
											</div> </>
										}
										</Dropdown.Menu>
									</Dropdown> 
									<div> 
										<Dropdown as="li" className="nav-item dropdown profile-dropdown  ms-4" id='drpUser'>
											<Dropdown.Toggle as="div" className="nav-link i-false">
												{/* <img src={profile } alt="/" /> */}
												{showUser.map((item, ind) => (

													<div className="profile-info" key={ind}>
														<h6 className="title">{item.CustName}</h6>
														{/* <span>info@gmail.com</span> */}
													</div>))}
											</Dropdown.Toggle>
											<Dropdown.Menu className="dropdown-menu py-0 dropdown-menu-end" style={{ height: "auto" }}>
												<div className="dropdown-header" >
													<h6 className="m-0">{showUser.CustName}</h6>
													{/* <span>info@gmail.com</span> */}
												</div>
												<div className="dropdown-body" >
													<Link to={"my-profile"} target="_parent"  className="dropdown-item d-flex justify-content-between align-items-center ai-icon">
														<div>
															<svg xmlns="http://www.w3.org/2000/svg" height="20px" viewBox="0 0 24 24" width="20px" fill="#000000"><path d="M0 0h24v24H0V0z" fill="none" /><path d="M12 6c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2m0 10c2.7 0 5.8 1.29 6 2H6c.23-.72 3.31-2 6-2m0-12C9.79 4 8 5.79 8 8s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm0 10c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z" /></svg>
															<span className="ms-2">Profile</span>
														</div>
													</Link>
													<Link to={"orderlist"} target="_parent"  className="dropdown-item d-flex justify-content-between align-items-center ai-icon">
														<div>
															<svg xmlns="http://www.w3.org/2000/svg" height="20px" viewBox="0 0 24 24" width="20px" fill="#000000"><path d="M0 0h24v24H0V0z" fill="none" /><path d="M15.55 13c.75 0 1.41-.41 1.75-1.03l3.58-6.49c.37-.66-.11-1.48-.87-1.48H5.21l-.94-2H1v2h2l3.6 7.59-1.35 2.44C4.52 15.37 5.48 17 7 17h12v-2H7l1.1-2h7.45zM6.16 6h12.15l-2.76 5H8.53L6.16 6zM7 18c-1.1 0-1.99.9-1.99 2S5.9 22 7 22s2-.9 2-2-.9-2-2-2zm10 0c-1.1 0-1.99.9-1.99 2s.89 2 1.99 2 2-.9 2-2-.9-2-2-2z" /></svg>
															<span className="ms-2">My Orders</span>
														</div>
													</Link>
													<Link to={"shop-cart"} target="_parent"  className="dropdown-item d-flex justify-content-between align-items-center ai-icon">
														<div>
															<svg xmlns="http://www.w3.org/2000/svg" height="20px" viewBox="0 0 24 24" width="24px" fill="#000000">
																<path d="M0 0h24v24H0V0z" fill="none" />
																<path d="M15.55 13c.75 0 1.41-.41 1.75-1.03l3.58-6.49c.37-.66-.11-1.48-.87-1.48H5.21l-.94-2H1v2h2l3.6 7.59-1.35 2.44C4.52 15.37 5.48 17 7 17h12v-2H7l1.1-2h7.45zM6.16 6h12.15l-2.76 5H8.53L6.16 6zM7 18c-1.1 0-1.99.9-1.99 2S5.9 22 7 22s2-.9 2-2-.9-2-2-2zm10 0c-1.1 0-1.99.9-1.99 2s.89 2 1.99 2 2-.9 2-2-.9-2-2-2z" />
															</svg>
															<span className="ms-2">My Cart</span>
														</div>
													</Link>
													<Link to={"wishlist"} target="_parent"  className="dropdown-item d-flex justify-content-between align-items-center ai-icon">
														<div>
															<svg xmlns="http://www.w3.org/2000/svg" height="20px" viewBox="0 0 24 24" width="20px" fill="#000000"><path d="M0 0h24v24H0V0z" fill="none" /><path d="M16.5 3c-1.74 0-3.41.81-4.5 2.09C10.91 3.81 9.24 3 7.5 3 4.42 3 2 5.42 2 8.5c0 3.78 3.4 6.86 8.55 11.54L12 21.35l1.45-1.32C18.6 15.36 22 12.28 22 8.5 22 5.42 19.58 3 16.5 3zm-4.4 15.55l-.1.1-.1-.1C7.14 14.24 4 11.39 4 8.5 4 6.5 5.5 5 7.5 5c1.54 0 3.04.99 3.57 2.36h1.87C13.46 5.99 14.96 5 16.5 5c2 0 3.5 1.5 3.5 3.5 0 2.89-3.14 5.74-7.9 10.05z" /></svg>
															<span className="ms-2">Wishlist</span>
														</div>
													</Link>
													<Link to={"my-ebooks"} target="_parent"  className="dropdown-item d-flex justify-content-between align-items-center ai-icon">
														<div>
														<i class="fa-solid fa-book" style={{color:'#f76d01'}}></i>
															<span className="ms-2">My EBooks</span>
														</div>
													</Link>
													<Link to={"subslist"} target="_parent"  className="dropdown-item d-flex justify-content-between align-items-center ai-icon">
														<div>
														<i class="fa-solid fa-book" style={{color:'#f76d01'}}></i>
															{/* <svg xmlns="http://www.w3.org/2000/svg" height="20px" viewBox="0 0 24 24" width="20px" fill="#000000"><path d="M0 0h24v24H0V0z" fill="none" /><path d="M16.5 3c-1.74 0-3.41.81-4.5 2.09C10.91 3.81 9.24 3 7.5 3 4.42 3 2 5.42 2 8.5c0 3.78 3.4 6.86 8.55 11.54L12 21.35l1.45-1.32C18.6 15.36 22 12.28 22 8.5 22 5.42 19.58 3 16.5 3zm-4.4 15.55l-.1.1-.1-.1C7.14 14.24 4 11.39 4 8.5 4 6.5 5.5 5 7.5 5c1.54 0 3.04.99 3.57 2.36h1.87C13.46 5.99 14.96 5 16.5 5c2 0 3.5 1.5 3.5 3.5 0 2.89-3.14 5.74-7.9 10.05z" /></svg> */}
															<span className="ms-2">My Subscriptions</span>
														</div>
													</Link>
													
												</div>
												<div className="dropdown-footer">
													<Link to={"shop-login "} target="_parent" className="btn btn-primary w-100 btnhover btn-sm" onClick={userLogOut} >Log Out</Link>
												</div>
											</Dropdown.Menu>
										</Dropdown>
									</div>
								</> : <>
									<Link to={"shop-login"} className="nav-link">
										<svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000"><path d="M0 0h24v24H0V0z" fill="none" /><path d="M16.5 3c-1.74 0-3.41.81-4.5 2.09C10.91 3.81 9.24 3 7.5 3 4.42 3 2 5.42 2 8.5c0 3.78 3.4 6.86 8.55 11.54L12 21.35l1.45-1.32C18.6 15.36 22 12.28 22 8.5 22 5.42 19.58 3 16.5 3zm-4.4 15.55l-.1.1-.1-.1C7.14 14.24 4 11.39 4 8.5 4 6.5 5.5 5 7.5 5c1.54 0 3.04.99 3.57 2.36h1.87C13.46 5.99 14.96 5 16.5 5c2 0 3.5 1.5 3.5 3.5 0 2.89-3.14 5.74-7.9 10.05z" /></svg>
									</Link> 
									<Dropdown as="li" className="nav-item" onClick={headeCartShow} >
										<Dropdown.Toggle as="button" type="button" className="nav-link box cart-btn i-false" >
											<svg xmlns="http://www.w3.org/2000/svg"   height="24px" viewBox="0 0 24 24" width="24px" fill="#000000">
												<path d="M0 0h24v24H0V0z" fill="none" />
												<path d="M15.55 13c.75 0 1.41-.41 1.75-1.03l3.58-6.49c.37-.66-.11-1.48-.87-1.48H5.21l-.94-2H1v2h2l3.6 7.59-1.35 2.44C4.52 15.37 5.48 17 7 17h12v-2H7l1.1-2h7.45zM6.16 6h12.15l-2.76 5H8.53L6.16 6zM7 18c-1.1 0-1.99.9-1.99 2S5.9 22 7 22s2-.9 2-2-.9-2-2-2zm10 0c-1.1 0-1.99.9-1.99 2s.89 2 1.99 2 2-.9 2-2-.9-2-2-2z" />
											</svg>
											<span className="badge"  id="TopCartOne">{CartCount}</span>
											{/* {count} */}
										</Dropdown.Toggle>
										<Dropdown.Menu as="ul" className={`dropdown-menu cart-list ${CartLoaded ? '' : 'displayB'}`} id="drp_CartList">
										
										{loading ? <> <Loader/>
										 </>:<>
										{headerCart2.map((data, index) => { TotNetAmount = TotNetAmount+ (data.ItemDiscountedPrice * data.Qty);  TotSaleCurrency = data.SaleCurrency;  total = data.ItemDiscountedPrice * data.Qty;
												// dIndex = index+1;
												return (
													
													<div key={index}>
														<li className="cart-item">
															<div className="media">
																<div className="media-left">
																	<Link to={"product-detail?q=" + data.ProductID} 
																	 >
																		<img alt={data.BookName} className="media-object" src={data.ProductImage} onError={(e) => e.target.src = noimage} />
																	</Link>
																</div>
																<div className="media-body" >
																	<h6 style={{ cursor: "pointer" }}>
																		<Link to={"product-detail?q=" + data.ProductID} 
																		 style={{ fontSize: '12px' }}>{data.BookName}</Link></h6>
																	<span className="dz-price">
																		
																				
																				<del className="cutPriceFont" >{SaleCurrency} {data.Price}</del>
																				<span className="priceCSS" > &nbsp;{SaleCurrency} {data.ItemDiscountedPrice}*{data.Qty} = {SaleCurrency} {total.toLocaleString('en-IN')}</span>
																		{/* {SaleCurrency} {data.Price}*{data.Qty} = {SaleCurrency} {total} */}
																	</span>
																</div>
															</div>
														</li>

													</div>)
											})}
									
											<div id="dv_CartList" className={`${CartLoaded ? '' : 'displayB'}`}>
												<li className="cart-item text-center">
													<h6 className="text-secondary">Total = {SaleCurrency} {TotNetAmount.toLocaleString('en-IN')}</h6>
												</li>
												<li className="text-center d-flex">
													<Link to={"shop-cart"}  className="btn btn-sm btn-primary me-2 btnhover w-100">View Cart</Link>
													<Link to={"shop-checkout"}   className="btn btn-sm btn-outline-primary btnhover w-100">Checkout</Link>
												</li>
											</div>
											<div id="dv_EmptyBlock" className={`displayB ${CartLoaded ? '':'showheadEmptrycart'}`} >
												<li className="cart-item text-center">
													<span className="text-secondary">Your Cart is Empty, Please add item into your cart.</span>
												</li>
											</div> 	</>}
										</Dropdown.Menu>
									</Dropdown>
									&nbsp; &nbsp; &nbsp;
									<Dropdown as="li" className="nav-item dropdown profile-dropdown  ms-4" id='drpLogin'>
									<div>
											<Link to={"shop-login"}  className="btn btn-primary w-100 btnhover btn-sm" >Login</Link>
										</div>
									</Dropdown>
								</>}
							</ul>
						</div>
					</div>

					{/* <!-- header search nav --> */}
					<div className="header-search-nav">
						<div className="header-item-search ">
							<div className="input-group search-input searchBaarleftradius searchBaarRightradius searchBaarBorder">
								<Dropdown className="dropdown bootstrap-select default-select drop-head">
									<Dropdown.Toggle as="div" className="i-false searchBaarleftradius">
										{selectBtn}<i className="ms-4 font-10 fa-solid fa-chevron-down"></i>
									</Dropdown.Toggle>
									<Dropdown.Menu>{
											Categorydata.map((data, index) => (
												<span key={index}>
													<Dropdown.Item className="SearchDrop" value={data.FilterName} onClick={() => setSelectBtn(data.FilterName)} >
														{data.FilterName}
													</Dropdown.Item>
												</span>
											))
										}
									</Dropdown.Menu>
								</Dropdown>
								{/* <div > */}
								<input id="txtSearch" type="text" onKeyUp={(e) => handler(e)} className="form-control searchBaarRightradius searchBaarBorder" placeholder="Search Books Here" autoComplete="nope" onKeyDown={(e) => handler(e)} />
									<button className="btn" type="button" onClick={() => handler("")}><i className="flaticon-loupe"></i></button> 
									{/* <button className="btn" type="button" onClick={() => handler("")}><i className="flaticon-loupe"></i></button> */}
								{/* </div>  */}
								{mySearchList.length !== 0 && (
									<div className='dataResult' id="dv_SearchList">
										{/* Note => if we use link here this work properly but there is one problem is that after refreshing all api not work , we need to use again refresh of the page. */}
										{mySearchList.slice(0, 10).map((data, index) => {
											return ( 
												<div className="dataItem" target="_blank" key={index} >
													
													<div>
														<Link target="_parent"  to={"product-detail?q=" + data.Book_Code}>
															<img className="CustomImage" src={data.ProductImage} onError={(e) => e.target.src = noimage} /> 
														</Link>
													</div>
													<div className='dataInfo'>
																<div>
																{data.IsEBook===true ?<><span style={{color: "#eaa451", fontSize:'16px', fontWeight:'600'}}>E Book</span></>:<></>}
																</div>
														<div className='dataBookName'>
															<Link target="_parent" to={"product-detail?q=" + data.Book_Code} style={{ textDecoration: "none" }}>
																<span className='textC'>Book ISBN:-</span> {data.Book_Code} 
															</Link>
														</div>
														<div className='dataBookName'>
															<Link target="_parent" to={"product-detail?q=" + data.Book_Code}style={{ textDecoration: "none" }}>
																<span className='textC'>Book Name:-</span> {data.Book_Name}
															</Link>
														</div>
														<div className='datainfo1 row'>
															<div className='col-lg-12'>
																<Link target="_parent" to={"book-shop-search?q=" + data.AuthorName} >
																	<span className='textC'>Author:-</span> {data.AuthorName}
																</Link>
															</div>
															<div className='col-lg-12'>
																<Link target="_parent" to={"book-shop-search?q=" + data.PublisherName} >
																	<span className='textC'>Publisher:-</span> {data.PublisherName}
																</Link>
															</div>
															<div className='col-lg-12'>
																<Link target="_parent" to={"book-shop-search?q=" +data.BookCategoryDesc} >
																	<span className='textC'>Category:-</span>{data.BookCategoryDesc}
																</Link>
															</div>
															<div className='col-lg-12'>{data.SalePrice === undefined || data.SalePrice ===null || data.SalePrice ==="" ?<>
															<span className='textC'>Price:-</span>{sessionStorage.getItem("LocalCurrency")} {data.SalePrice}
															</>:<><span className='textC'>Price:-</span>{sessionStorage.getItem("LocalCurrency")} {data.SalePrice.toLocaleString('en-IN')} </>}
																
															</div>
														</div>

													</div>
												</div>
											);
										})}
									</div>
								)}
							</div>
						</div>
					</div>
				</div>  
			</div> 
			<div className={`sticky-header main-bar-wraper navbar-expand-lg ${headerFix ? "is-fixed" : ""} `}>
				<div className="main-bar clearfix">
					<div className="container clearfix">
						{/* <!-- Website Logo --> */}
						<div className="logo-header logo-dark">
							<Link to={""}><img src={logo} alt="logo" /></Link>
						</div>

						{/* <!-- Nav Toggle Button --> */}
						<button className={`navbar-toggler collapsed navicon justify-content-end ${sidebarOpen ? 'open' : ''}`} onClick={showSidebar} ><span></span><span></span><span></span></button>

						{/* <!-- EXTRA NAV --> */}
						<div className="extra-nav getTouch">
							<div className={`extra-cell ${headerFix ? "menuHide" : "menuShow"} hidaicon`}>
								{/* <a href={"https://api.whatsapp.com/send?phone=919827067201&amp;text='Hello! I would like to know more about your Services and Offers'"} 
									target="_blank" className="btn btn-primary btnhover btnbgColor getTouch">Get In Touch</a> */}
								<a href={"/contact-us"}   className="btn btn-primary btnhover btnbgColor getTouch">Contact Us</a>								
							</div>
							{/* <li className={`nav-item ${headerFix ? "menuShow" : "menuHide"}`}>
								<Link to={"wishlist"} className="nav-link">
									<svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000"><path d="M0 0h24v24H0V0z" fill="none" /><path d="M16.5 3c-1.74 0-3.41.81-4.5 2.09C10.91 3.81 9.24 3 7.5 3 4.42 3 2 5.42 2 8.5c0 3.78 3.4 6.86 8.55 11.54L12 21.35l1.45-1.32C18.6 15.36 22 12.28 22 8.5 22 5.42 19.58 3 16.5 3zm-4.4 15.55l-.1.1-.1-.1C7.14 14.24 4 11.39 4 8.5 4 6.5 5.5 5 7.5 5c1.54 0 3.04.99 3.57 2.36h1.87C13.46 5.99 14.96 5 16.5 5c2 0 3.5 1.5 3.5 3.5 0 2.89-3.14 5.74-7.9 10.05z" /></svg>
									<span className="badge">{Userdata.wishListCount}</span>
								</Link>
							</li> */}
							<ul className={`navbar-nav header-right ${headerFix ? "menuShow" : "menuHide"} hidaicon`}>
								{User !== "guest"  ? <>
									<li className="nav-item">
										<Link to={"wishlist"} target="_parent"  className="nav-link btn btn-primary iconFont minpadding" >
											{/* <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000"><path d="M0 0h24v24H0V0z" fill="none" /><path d="M16.5 3c-1.74 0-3.41.81-4.5 2.09C10.91 3.81 9.24 3 7.5 3 4.42 3 2 5.42 2 8.5c0 3.78 3.4 6.86 8.55 11.54L12 21.35l1.45-1.32C18.6 15.36 22 12.28 22 8.5 22 5.42 19.58 3 16.5 3zm-4.4 15.55l-.1.1-.1-.1C7.14 14.24 4 11.39 4 8.5 4 6.5 5.5 5 7.5 5c1.54 0 3.04.99 3.57 2.36h1.87C13.46 5.99 14.96 5 16.5 5c2 0 3.5 1.5 3.5 3.5 0 2.89-3.14 5.74-7.9 10.05z" /></svg> */}
											<i className="flaticon-heart"></i><span className="badge" id='secondWish'>{LoadCountWish}</span>
										</Link>
									</li>
									<Dropdown as="li" className="nav-item"  onClick={headeCartShow}>
										<Dropdown.Toggle as="button" type="button" className="nav-link btn btn-primary iconFont minpadding i-false">
											<span  >
										<i className="flaticon-shopping-cart-1"></i></span>
											{/* <svg xmlns="http://www.w3.org/2000/svg" onClick={headeCartShow} height="24px" viewBox="0 0 24 24" width="24px" fill="#000000">
												<path d="M0 0h24v24H0V0z" fill="none" />
												<path d="M15.55 13c.75 0 1.41-.41 1.75-1.03l3.58-6.49c.37-.66-.11-1.48-.87-1.48H5.21l-.94-2H1v2h2l3.6 7.59-1.35 2.44C4.52 15.37 5.48 17 7 17h12v-2H7l1.1-2h7.45zM6.16 6h12.15l-2.76 5H8.53L6.16 6zM7 18c-1.1 0-1.99.9-1.99 2S5.9 22 7 22s2-.9 2-2-.9-2-2-2zm10 0c-1.1 0-1.99.9-1.99 2s.89 2 1.99 2 2-.9 2-2-.9-2-2-2z" />
											</svg> */}
											{/* <i className="fa fa-heart"></i> */}
											<span className="badge spnIDCount" id="spnIDOnScroll">{count}</span>
											{/* {count} */}
										</Dropdown.Toggle>
										<Dropdown.Menu as="ul" className="dropdown-menu cart-list" id="drp_CartList">
												
										{loading ? <> <Loader/>
										 </>:<>
											{headerCart3.map((data, index) => { TtNetAmount = TtNetAmount+ (data.ItemDiscountedPrice * data.Qty);  TotSaleCurrency = data.SaleCurrency;  totalamt = data.ItemDiscountedPrice * data.Qty;
												// dIndex = index+1;
												return (  
													<div key={index}>
														<li className="cart-item">
															<div className="media">
																<div className="media-left">
																	<Link to={"product-detail?q=" + data.ProductID} >
																		<img alt={data.BookName} className="media-object" src={data.ProductImage} onError={(e) => e.target.src = noimage} />
																	</Link>
																</div>
																<div className="media-body" >
																	<h6 style={{ cursor: "pointer" }}>
																		<Link to={"product-detail?q=" + data.ProductID}  style={{ fontSize: '12px' }}>{data.BookName}</Link></h6>
																	<span className="dz-price">
																		
																				
																				<del className="cutPriceFont" >{SaleCurrency} {data.Price}</del>
																				<span className="priceCSS" > &nbsp;{SaleCurrency} {data.ItemDiscountedPrice}*{data.Qty} = {SaleCurrency} {totalamt.toLocaleString('en-IN')}</span>
																		{/* {SaleCurrency} {data.Price}*{data.Qty} = {SaleCurrency} {total} */}
																	</span>
																</div>
															</div>
														</li>

													</div>)
											})}
											<div id="dv_CartList" className={`${CartLoaded ? '' : 'displayB'}`}>
												<li className="cart-item text-center">
													<h6 className="text-secondary">Total = {SaleCurrency} {TtNetAmount.toLocaleString('en-IN')}</h6>
												</li>
												<li className="text-center d-flex">
													<Link to={"shop-cart"}  className="btn btn-sm btn-primary me-2 btnhover w-100">View Cart</Link>
													<Link to={"shop-checkout"}  className="btn btn-sm btn-outline-primary btnhover w-100">Checkout</Link>
												</li>
											</div>
											<div id="dv_EmptyBlock"  className={`displayB ${CartLoaded ? '':'showheadEmptrycart'}`}>
												<li className="cart-item text-center">
													<span className="text-secondary">Your Cart is Empty, Please add item into your cart.</span>
												</li>
											</div>
                                                  </>}
										</Dropdown.Menu>
									</Dropdown> 
									<div> 
										<Dropdown as="li" className="nav-item dropdown profile-dropdown" id='drpUser'>
											<Dropdown.Toggle as="div" className="nav-link i-false">
												{showUser.map((item, ind) => ( 
														<div className="profile-info" key={ind}>
															<span className="title textColor">{item.CustName}</span> 
														</div>
														))
													} 
											</Dropdown.Toggle>
											<Dropdown.Menu className="dropdown-menu py-0 dropdown-menu-end" style={{ height: "auto" }}>
												<div className="dropdown-header" >
													<h6 className="m-0">{showUser.CustName}</h6>
													{/* <span>info@gmail.com</span> */}
												</div>
												<div className="dropdown-body" >
													<Link to={"my-profile"} className="dropdown-item d-flex justify-content-between align-items-center ai-icon">
														<div>
															<svg xmlns="http://www.w3.org/2000/svg" height="20px" viewBox="0 0 24 24" width="20px" fill="#000000"><path d="M0 0h24v24H0V0z" fill="none" /><path d="M12 6c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2m0 10c2.7 0 5.8 1.29 6 2H6c.23-.72 3.31-2 6-2m0-12C9.79 4 8 5.79 8 8s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm0 10c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z" /></svg>
															<span className="ms-2">Profile</span>
														</div>
													</Link>
													<Link to={"orderlist"} className="dropdown-item d-flex justify-content-between align-items-center ai-icon">
														<div>
															<svg xmlns="http://www.w3.org/2000/svg" height="20px" viewBox="0 0 24 24" width="20px" fill="#000000"><path d="M0 0h24v24H0V0z" fill="none" /><path d="M15.55 13c.75 0 1.41-.41 1.75-1.03l3.58-6.49c.37-.66-.11-1.48-.87-1.48H5.21l-.94-2H1v2h2l3.6 7.59-1.35 2.44C4.52 15.37 5.48 17 7 17h12v-2H7l1.1-2h7.45zM6.16 6h12.15l-2.76 5H8.53L6.16 6zM7 18c-1.1 0-1.99.9-1.99 2S5.9 22 7 22s2-.9 2-2-.9-2-2-2zm10 0c-1.1 0-1.99.9-1.99 2s.89 2 1.99 2 2-.9 2-2-.9-2-2-2z" /></svg>
															<span className="ms-2">My Orders</span>
														</div>
													</Link>
													<Link to={"shop-cart"}  className="dropdown-item d-flex justify-content-between align-items-center ai-icon">
														<div>
															<svg xmlns="http://www.w3.org/2000/svg" height="20px" viewBox="0 0 24 24" width="24px" fill="#000000">
																<path d="M0 0h24v24H0V0z" fill="none" />
																<path d="M15.55 13c.75 0 1.41-.41 1.75-1.03l3.58-6.49c.37-.66-.11-1.48-.87-1.48H5.21l-.94-2H1v2h2l3.6 7.59-1.35 2.44C4.52 15.37 5.48 17 7 17h12v-2H7l1.1-2h7.45zM6.16 6h12.15l-2.76 5H8.53L6.16 6zM7 18c-1.1 0-1.99.9-1.99 2S5.9 22 7 22s2-.9 2-2-.9-2-2-2zm10 0c-1.1 0-1.99.9-1.99 2s.89 2 1.99 2 2-.9 2-2-.9-2-2-2z" />
															</svg>
															<span className="ms-2">My Cart</span>
														</div>
													</Link>
													<Link to={"wishlist"} className="dropdown-item d-flex justify-content-between align-items-center ai-icon">
														<div>
															<svg xmlns="http://www.w3.org/2000/svg" height="20px" viewBox="0 0 24 24" width="20px" fill="#000000"><path d="M0 0h24v24H0V0z" fill="none" /><path d="M16.5 3c-1.74 0-3.41.81-4.5 2.09C10.91 3.81 9.24 3 7.5 3 4.42 3 2 5.42 2 8.5c0 3.78 3.4 6.86 8.55 11.54L12 21.35l1.45-1.32C18.6 15.36 22 12.28 22 8.5 22 5.42 19.58 3 16.5 3zm-4.4 15.55l-.1.1-.1-.1C7.14 14.24 4 11.39 4 8.5 4 6.5 5.5 5 7.5 5c1.54 0 3.04.99 3.57 2.36h1.87C13.46 5.99 14.96 5 16.5 5c2 0 3.5 1.5 3.5 3.5 0 2.89-3.14 5.74-7.9 10.05z" /></svg>
															<span className="ms-2">Wishlist</span>
														</div>
													</Link>
													<Link to={"my-ebooks"} className="dropdown-item d-flex justify-content-between align-items-center ai-icon">
														<div>
														<i class="fa-solid fa-book"></i>
															{/* <svg xmlns="http://www.w3.org/2000/svg" height="20px" viewBox="0 0 24 24" width="20px" fill="#000000"><path d="M0 0h24v24H0V0z" fill="none" /><path d="M16.5 3c-1.74 0-3.41.81-4.5 2.09C10.91 3.81 9.24 3 7.5 3 4.42 3 2 5.42 2 8.5c0 3.78 3.4 6.86 8.55 11.54L12 21.35l1.45-1.32C18.6 15.36 22 12.28 22 8.5 22 5.42 19.58 3 16.5 3zm-4.4 15.55l-.1.1-.1-.1C7.14 14.24 4 11.39 4 8.5 4 6.5 5.5 5 7.5 5c1.54 0 3.04.99 3.57 2.36h1.87C13.46 5.99 14.96 5 16.5 5c2 0 3.5 1.5 3.5 3.5 0 2.89-3.14 5.74-7.9 10.05z" /></svg> */}
															<span className="ms-2">My EBooks</span>
														</div>
													</Link>
													<Link to={"my-subs"}  className="dropdown-item d-flex justify-content-between align-items-center ai-icon">
														<div>
														<i class="fa-solid fa-book"></i>
															{/* <svg xmlns="http://www.w3.org/2000/svg" height="20px" viewBox="0 0 24 24" width="20px" fill="#000000"><path d="M0 0h24v24H0V0z" fill="none" /><path d="M16.5 3c-1.74 0-3.41.81-4.5 2.09C10.91 3.81 9.24 3 7.5 3 4.42 3 2 5.42 2 8.5c0 3.78 3.4 6.86 8.55 11.54L12 21.35l1.45-1.32C18.6 15.36 22 12.28 22 8.5 22 5.42 19.58 3 16.5 3zm-4.4 15.55l-.1.1-.1-.1C7.14 14.24 4 11.39 4 8.5 4 6.5 5.5 5 7.5 5c1.54 0 3.04.99 3.57 2.36h1.87C13.46 5.99 14.96 5 16.5 5c2 0 3.5 1.5 3.5 3.5 0 2.89-3.14 5.74-7.9 10.05z" /></svg> */}
															<span className="ms-2">My Subscriptions</span>
														</div>
													</Link>
												</div>
												<div className="dropdown-footer">
													<Link to={"shop-login"} className="btn btn-primary w-100 btnhover btn-sm" onClick={userLogOut} >Log Out</Link>
												</div>
											</Dropdown.Menu>
										</Dropdown>
									</div>
								</> : <> 
									<li className="nav-item">
										<Link to={"shop-login"} className="nav-link btn btn-primary iconFont minpadding" >
											{/* <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000"><path d="M0 0h24v24H0V0z" fill="none" /><path d="M16.5 3c-1.74 0-3.41.81-4.5 2.09C10.91 3.81 9.24 3 7.5 3 4.42 3 2 5.42 2 8.5c0 3.78 3.4 6.86 8.55 11.54L12 21.35l1.45-1.32C18.6 15.36 22 12.28 22 8.5 22 5.42 19.58 3 16.5 3zm-4.4 15.55l-.1.1-.1-.1C7.14 14.24 4 11.39 4 8.5 4 6.5 5.5 5 7.5 5c1.54 0 3.04.99 3.57 2.36h1.87C13.46 5.99 14.96 5 16.5 5c2 0 3.5 1.5 3.5 3.5 0 2.89-3.14 5.74-7.9 10.05z" /></svg> */}
											<i className="flaticon-heart"></i><span className="badge">{Userdata.wishListCount}</span>
										</Link>
									</li>{/*
									<li className="nav-item">
										<Link to={"shop-login"} className="nav-link btn btn-primary iconFont minpadding">
											 <svg xmlns="http://www.w3.org/2000/svg" onClick={headeCartShow} height="24px" viewBox="0 0 24 24" width="24px" fill="#000000"><path d="M0 0h24v24H0V0z" fill="none" /><path d="M15.55 13c.75 0 1.41-.41 1.75-1.03l3.58-6.49c.37-.66-.11-1.48-.87-1.48H5.21l-.94-2H1v2h2l3.6 7.59-1.35 2.44C4.52 15.37 5.48 17 7 17h12v-2H7l1.1-2h7.45zM6.16 6h12.15l-2.76 5H8.53L6.16 6zM7 18c-1.1 0-1.99.9-1.99 2S5.9 22 7 22s2-.9 2-2-.9-2-2-2zm10 0c-1.1 0-1.99.9-1.99 2s.89 2 1.99 2 2-.9 2-2-.9-2-2-2z" /></svg> 
											<i className="flaticon-shopping-cart-1"></i><span className="badge spnIDCount"   id="TopCartThree">{CartCount}</span>
										</Link>
										
									</li> */}
									<Dropdown as="li" className="nav-item" onClick={headeCartShow} >
										<Dropdown.Toggle as="button" type="button" className="nav-link btn btn-primary iconFont minpadding box cart-btn i-false" >
										<span  >
										<i className="flaticon-shopping-cart-1"></i></span>
											{/* <svg xmlns="http://www.w3.org/2000/svg" onClick={headeCartShow}   height="24px" viewBox="0 0 24 24" width="24px" fill="#000000">
												<path d="M0 0h24v24H0V0z" fill="none" />
												<path d="M15.55 13c.75 0 1.41-.41 1.75-1.03l3.58-6.49c.37-.66-.11-1.48-.87-1.48H5.21l-.94-2H1v2h2l3.6 7.59-1.35 2.44C4.52 15.37 5.48 17 7 17h12v-2H7l1.1-2h7.45zM6.16 6h12.15l-2.76 5H8.53L6.16 6zM7 18c-1.1 0-1.99.9-1.99 2S5.9 22 7 22s2-.9 2-2-.9-2-2-2zm10 0c-1.1 0-1.99.9-1.99 2s.89 2 1.99 2 2-.9 2-2-.9-2-2-2z" />
											</svg> */}
											{/* <span className="badge"  id="TopCartOne">{CartCount}</span> */}
											
											<span className="badge spnIDCount"   id="spnIDOnScroll">{CartCount}</span>
											{/* {count} */}
										</Dropdown.Toggle>
										<Dropdown.Menu as="ul" className={`dropdown-menu cart-list`} id="drp_CartList">
												
										{loading ? <> <Loader/>
										 </>:<>
											{headerCart4.map((data, index) => 
												{ 
													TNetAmount = TNetAmount+ (data.ItemDiscountedPrice * data.Qty);  TotSaleCurrency = data.SaleCurrency;  toalamt = data.ItemDiscountedPrice * data.Qty;
													
												// dIndex = index+1;
												return (
													<div key={index}>
														<li className="cart-item">
															{
																
															}
															<div className="media">
																<div className="media-left">
																	<Link to={"product-detail?q=" + data.ProductID}  >
																		<img alt={data.BookName} className="media-object" src={data.ProductImage} onError={(e) => e.target.src = noimage} />
																	</Link>
																</div>
																<div className="media-body" >
																	<h6 style={{ cursor: "pointer" }}>
																		<Link to={"product-detail?q=" + data.ProductID}    style={{ fontSize: '12px' }}>{data.BookName}</Link></h6>
																	<span className="dz-price">
																		
																				
																				<del className="cutPriceFont" >{SaleCurrency} {data.Price}</del>
																				<span className="priceCSS" > &nbsp;{SaleCurrency} {data.ItemDiscountedPrice}*{data.Qty} = {SaleCurrency} {toalamt.toLocaleString('en-IN')}</span>
																		{/* {SaleCurrency} {data.Price}*{data.Qty} = {SaleCurrency} {total} */}
																	</span>
																</div>
															</div>
														</li>

													</div>)
											})}
											<div id="dv_CartList" className={`${CartLoaded ? '' : 'displayB'}`}>
												<li className="cart-item text-center">
													<h6 className="text-secondary">Total = {SaleCurrency} {TNetAmount.toLocaleString('en-IN')}</h6>
												</li>
												<li className="text-center d-flex">
													<Link to={"shop-cart"} target="_parent"  className="btn btn-sm btn-primary me-2 btnhover w-100">View Cart</Link>
													<Link to={"shop-checkout"} target="_parent"  className="btn btn-sm btn-outline-primary btnhover w-100">Checkout</Link>
												</li>
											</div>
											<div id="dv_EmptyBlock"  className={`displayB ${CartLoaded ? '':'showheadEmptrycart'}`} >
												<li className="cart-item text-center">
													<span className="text-secondary">Your Cart is Empty, Please add item into your cart.</span>
												</li>
											</div> 
											 </>}
										</Dropdown.Menu>
									</Dropdown> 
									<Dropdown as="li" className="nav-item dropdown profile-dropdown" id='drpLogin'>
										<div className="dropdown-footer">
											<Link to={"shop-login"}  className="btn btn-primary w-100 btnhover btn-sm textColor" >Login</Link>
										</div>
									</Dropdown>
								</>}
							</ul>
						</div>
						<Toaster position="top-right" reverseOrder={false} gutter={1} toastOptions={{ duration: 1000, style: { background: 'green', color: '#fff',},}}  /> 
						{/* <!-- Main Nav --> */}
						<div ref={closeMenu} className={`header-nav navbar-collapse collapse justify-content-start ${(sidebarOpen !== CartClicked) ? 'show': ''}`} id="navbarNavDropdown">
							<div className="logo-header logo-dark">
								<Link to={""}><img src={logo} alt="Bhavisa Foundations" /></Link>
							</div>
							<div className="search-input">
								<div className="input-group">
									<input id="txtSearchMobile" type="text" onKeyUp={(e) => handlerM(e)} //aria-label="Text input with dropdown button"
										className="form-control searchBaarleftradius searchBaarRightradius searchBaarBorder" placeholder="Search Books Here" autoComplete='off' />									 
									<button className="btn" type="button"  ><i className="flaticon-loupe"></i></button>  
									{mySearchList1.length !== 0 && (
										<div className='dataResult'>
											{mySearchList1.slice(0, 10).map((data, key) => {
												return (
													<div className="dataItem" target="_blank" >
														<div>{/* <img src={data.ProductImage} className="imageIcon" /> */}
														<Link  target="_parent"  to={"product-detail?q=" + data.Book_Code}>	<img className="CustomImage1" src={data.ProductImage} onError={(e) => e.target.src = noimage} /></Link>
														</div>
														<div className='dataInfo'>
															<div className='MdataBookName'><Link target="_parent" to={"product-detail?q=" + data.Book_Code} style={{ textDecoration: "none" }}>{data.Book_Name}</Link></div>
															<div className='datainfo1'>
																<div >Author: <Link to={"book-shop-search?q=" + data.AuthorName} target="_parent" className='MdataBookName'> {data.AuthorName}</Link></div>
																{/* <div >Publisher: &nbsp;&nbsp;<Link to={"product-detail?q=" + data.PublisherName} className='MdataBookName'>{data.PublisherName}</Link></div> */}
															</div>

														</div>
													</div>
												);
											})}
										</div>
									)}
								</div>
							</div>
							<div className="search-input">
								{User !== "guest"  ? 
										<>
											<li className="nav-item">
												<Link to={"wishlist"} target="_parent" className="nav-link">
													<svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000"><path d="M0 0h24v24H0V0z" fill="none" /><path d="M16.5 3c-1.74 0-3.41.81-4.5 2.09C10.91 3.81 9.24 3 7.5 3 4.42 3 2 5.42 2 8.5c0 3.78 3.4 6.86 8.55 11.54L12 21.35l1.45-1.32C18.6 15.36 22 12.28 22 8.5 22 5.42 19.58 3 16.5 3zm-4.4 15.55l-.1.1-.1-.1C7.14 14.24 4 11.39 4 8.5 4 6.5 5.5 5 7.5 5c1.54 0 3.04.99 3.57 2.36h1.87C13.46 5.99 14.96 5 16.5 5c2 0 3.5 1.5 3.5 3.5 0 2.89-3.14 5.74-7.9 10.05z" /></svg>
													<span className="badge" id='Wishmob'>{Userdata.wishListCount}</span>
												</Link>
											</li>
											<li className="nav-item">
												<Link to={"shop-cart"} target="_parent" className="nav-link">
													<svg xmlns="http://www.w3.org/2000/svg"  height="24px" viewBox="0 0 24 24" width="24px" fill="#000000">
														<path d="M0 0h24v24H0V0z" fill="none" />
														<path d="M15.55 13c.75 0 1.41-.41 1.75-1.03l3.58-6.49c.37-.66-.11-1.48-.87-1.48H5.21l-.94-2H1v2h2l3.6 7.59-1.35 2.44C4.52 15.37 5.48 17 7 17h12v-2H7l1.1-2h7.45zM6.16 6h12.15l-2.76 5H8.53L6.16 6zM7 18c-1.1 0-1.99.9-1.99 2S5.9 22 7 22s2-.9 2-2-.9-2-2-2zm10 0c-1.1 0-1.99.9-1.99 2s.89 2 1.99 2 2-.9 2-2-.9-2-2-2z" />
													</svg>
													<span className="badge bageMobile" id="TopCartFour">{CartCount}</span>
												</Link>
											</li>
										</>: 
										<>
											<Link to={"shop-cart"} target="_parent" className="nav-link">
												<svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000"><path d="M0 0h24v24H0V0z" fill="none" /><path d="M16.5 3c-1.74 0-3.41.81-4.5 2.09C10.91 3.81 9.24 3 7.5 3 4.42 3 2 5.42 2 8.5c0 3.78 3.4 6.86 8.55 11.54L12 21.35l1.45-1.32C18.6 15.36 22 12.28 22 8.5 22 5.42 19.58 3 16.5 3zm-4.4 15.55l-.1.1-.1-.1C7.14 14.24 4 11.39 4 8.5 4 6.5 5.5 5 7.5 5c1.54 0 3.04.99 3.57 2.36h1.87C13.46 5.99 14.96 5 16.5 5c2 0 3.5 1.5 3.5 3.5 0 2.89-3.14 5.74-7.9 10.05z" /></svg>										
											</Link> 
											<Link to={"shop-cart"} target="_parent" className="nav-link">
												<svg xmlns="http://www.w3.org/2000/svg" onClick={headeCartShow} height="24px" viewBox="0 0 24 24" width="24px" fill="#000000"><path d="M0 0h24v24H0V0z" fill="none" /><path d="M15.55 13c.75 0 1.41-.41 1.75-1.03l3.58-6.49c.37-.66-.11-1.48-.87-1.48H5.21l-.94-2H1v2h2l3.6 7.59-1.35 2.44C4.52 15.37 5.48 17 7 17h12v-2H7l1.1-2h7.45zM6.16 6h12.15l-2.76 5H8.53L6.16 6zM7 18c-1.1 0-1.99.9-1.99 2S5.9 22 7 22s2-.9 2-2-.9-2-2-2zm10 0c-1.1 0-1.99.9-1.99 2s.89 2 1.99 2 2-.9 2-2-.9-2-2-2z" /></svg>
												<span className="badge bageMobile" id="TopCartFive">{CartCount}</span>
											</Link> 
										</>
								}
							</div>
							<ul className="nav navbar-nav"> 							
								{MenuListArray2.map((data, index) => {
									return ( 
										<li key={index} className={`${(active === data.title) && (data.content) ? 'sub-menu-down open' : data.content ? 'sub-menu-down' : ''}`} > 
											{
												data.title === "Contact Us" ? "":


												data.title === "International Curriculum" ? 
												<Link     target=""   className={`${headerFix ? "menuHide" : "menuShow"} hidaicon`}  to={data.content ? "#" : data.to}  >
													<span>{data.title}</span>
												</Link>
												:
												<Link  target="_parent"    className={`${headerFix ? "menuHide" : "menuShow"} hidaicon`}  to={data.content ? "#" : data.to} onClick={() => handleMenuActive(data.title)} >
													<span>{data.title}</span>
												</Link>
											}
														{
												 

												data.title === "International Curriculum" ?  
												<Link     className={`${headerFix ? "menuShow" : "menuHide"}`}  to={data.content ? "#" : data.to}  onClick={() => handleMenuActive(data.title)} >
												<span>{data.title} </span>
											</Link> 
												:
												<Link   target="_parent"  className={`${headerFix ? "menuShow" : "menuHide"}`}  to={data.content ? "#" : data.to}   >
												<span>{data.title} </span>
											</Link> 
											}
											{data.content &&
												<Collapse in={active === data.title ? true : false}>
													<ul className="sub-menu">
														{data.content && data.content.map((data, index) => {
															return (
																<li key={index}>
																	<Link  to={data.to}>{data.title}</Link>
																</li>
															)
														})}
													</ul>
												</Collapse>
											}
											
										</li>

									)
								})}
								
								<li><Link to="subscribe" >Subscriptions</Link></li> 
								<li>{User !== "guest" ? <><Link to="my-ebooks" >Read EBook</Link></>:<></>}</li> 
								<li>{User !== "guest" ? <><Link  to="subslist" >My Subscriptions</Link></>:<></>}</li> 
								<li>{User !== "guest" ? <><Link to="my-subs" >Read E-Magazine</Link></>:<></>}</li>
								<li>{User !== "guest" ? <><Link to="free-ebooks" >Free E-Book</Link></>:<></>}</li>
							</ul>

							{User !== "guest"  ? <>
								<Dropdown as="li" className="nav navbar-nav mobileView" id='drpUser' >
									<Dropdown.Toggle as="div" className="nav-link i-false">
										{/* <img src={profile } alt="/" /> */}
										{showUser.map((item, ind) => (
											<div className="profile-info" key={ind}><h6 className="title">{item.CustName}</h6>{/* <span>info@gmail.com</span> */}</div>))}
									</Dropdown.Toggle>
									<Dropdown.Menu className="dropdown-menu py-0 dropdown-menu-end" style={{ height: "auto" }}>
										<div className="dropdown-header" >
											<h6 className="m-0">{showUser.CustName}</h6>
											{/* <span>info@gmail.com</span> */}
										</div>
										<div className="dropdown-body" >
											<Link to={"my-profile"} target="_parent" className="dropdown-item d-flex justify-content-between align-items-center ai-icon">
												<div>
													<svg xmlns="http://www.w3.org/2000/svg" height="20px" viewBox="0 0 24 24" width="20px" fill="#000000"><path d="M0 0h24v24H0V0z" fill="none" /><path d="M12 6c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2m0 10c2.7 0 5.8 1.29 6 2H6c.23-.72 3.31-2 6-2m0-12C9.79 4 8 5.79 8 8s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm0 10c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z" /></svg>
													<span className="ms-2">Profile</span>
												</div>
											</Link>
											<Link to={"myorder"} target="_parent" className="dropdown-item d-flex justify-content-between align-items-center ai-icon">
												<div>
													<svg xmlns="http://www.w3.org/2000/svg" height="20px" viewBox="0 0 24 24" width="20px" fill="#000000"><path d="M0 0h24v24H0V0z" fill="none" /><path d="M15.55 13c.75 0 1.41-.41 1.75-1.03l3.58-6.49c.37-.66-.11-1.48-.87-1.48H5.21l-.94-2H1v2h2l3.6 7.59-1.35 2.44C4.52 15.37 5.48 17 7 17h12v-2H7l1.1-2h7.45zM6.16 6h12.15l-2.76 5H8.53L6.16 6zM7 18c-1.1 0-1.99.9-1.99 2S5.9 22 7 22s2-.9 2-2-.9-2-2-2zm10 0c-1.1 0-1.99.9-1.99 2s.89 2 1.99 2 2-.9 2-2-.9-2-2-2z" /></svg>
													<span className="ms-2">My Orders</span>
												</div>
											</Link>
											<Link to={"shop-cart"} target="_parent" className="dropdown-item d-flex justify-content-between align-items-center ai-icon">
												<div>
													<svg xmlns="http://www.w3.org/2000/svg" height="20px" viewBox="0 0 24 24" width="24px" fill="#000000">
														<path d="M0 0h24v24H0V0z" fill="none" />
														<path d="M15.55 13c.75 0 1.41-.41 1.75-1.03l3.58-6.49c.37-.66-.11-1.48-.87-1.48H5.21l-.94-2H1v2h2l3.6 7.59-1.35 2.44C4.52 15.37 5.48 17 7 17h12v-2H7l1.1-2h7.45zM6.16 6h12.15l-2.76 5H8.53L6.16 6zM7 18c-1.1 0-1.99.9-1.99 2S5.9 22 7 22s2-.9 2-2-.9-2-2-2zm10 0c-1.1 0-1.99.9-1.99 2s.89 2 1.99 2 2-.9 2-2-.9-2-2-2z" />
													</svg>
													<span className="ms-2">My Cart</span>
												</div>
											</Link>
											<Link to={"wishlist"}  target="_parent" className="dropdown-item d-flex justify-content-between align-items-center ai-icon">
												<div>
													<svg xmlns="http://www.w3.org/2000/svg" height="20px" viewBox="0 0 24 24" width="20px" fill="#000000"><path d="M0 0h24v24H0V0z" fill="none" /><path d="M16.5 3c-1.74 0-3.41.81-4.5 2.09C10.91 3.81 9.24 3 7.5 3 4.42 3 2 5.42 2 8.5c0 3.78 3.4 6.86 8.55 11.54L12 21.35l1.45-1.32C18.6 15.36 22 12.28 22 8.5 22 5.42 19.58 3 16.5 3zm-4.4 15.55l-.1.1-.1-.1C7.14 14.24 4 11.39 4 8.5 4 6.5 5.5 5 7.5 5c1.54 0 3.04.99 3.57 2.36h1.87C13.46 5.99 14.96 5 16.5 5c2 0 3.5 1.5 3.5 3.5 0 2.89-3.14 5.74-7.9 10.05z" /></svg>
													<span className="ms-2">Wishlist</span>
												</div>
											</Link>
											 <Link to={"my-ebooks"} target="_parent"  className="dropdown-item d-flex justify-content-between align-items-center ai-icon">
											     <div>
														<i class="fa-solid fa-book"></i>
															{/* <svg xmlns="http://www.w3.org/2000/svg" height="20px" viewBox="0 0 24 24" width="20px" fill="#000000"><path d="M0 0h24v24H0V0z" fill="none" /><path d="M16.5 3c-1.74 0-3.41.81-4.5 2.09C10.91 3.81 9.24 3 7.5 3 4.42 3 2 5.42 2 8.5c0 3.78 3.4 6.86 8.55 11.54L12 21.35l1.45-1.32C18.6 15.36 22 12.28 22 8.5 22 5.42 19.58 3 16.5 3zm-4.4 15.55l-.1.1-.1-.1C7.14 14.24 4 11.39 4 8.5 4 6.5 5.5 5 7.5 5c1.54 0 3.04.99 3.57 2.36h1.87C13.46 5.99 14.96 5 16.5 5c2 0 3.5 1.5 3.5 3.5 0 2.89-3.14 5.74-7.9 10.05z" /></svg> */}
															<span className="ms-2">My EBooks</span>
														</div>
													</Link>
													<Link to={"subslist"} target="_parent"  className="dropdown-item d-flex justify-content-between align-items-center ai-icon">
														<div>
														<i class="fa-solid fa-book"></i>
															{/* <svg xmlns="http://www.w3.org/2000/svg" height="20px" viewBox="0 0 24 24" width="20px" fill="#000000"><path d="M0 0h24v24H0V0z" fill="none" /><path d="M16.5 3c-1.74 0-3.41.81-4.5 2.09C10.91 3.81 9.24 3 7.5 3 4.42 3 2 5.42 2 8.5c0 3.78 3.4 6.86 8.55 11.54L12 21.35l1.45-1.32C18.6 15.36 22 12.28 22 8.5 22 5.42 19.58 3 16.5 3zm-4.4 15.55l-.1.1-.1-.1C7.14 14.24 4 11.39 4 8.5 4 6.5 5.5 5 7.5 5c1.54 0 3.04.99 3.57 2.36h1.87C13.46 5.99 14.96 5 16.5 5c2 0 3.5 1.5 3.5 3.5 0 2.89-3.14 5.74-7.9 10.05z" /></svg> */}
															<span className="ms-2">My Subscriptions</span>
														</div>
													</Link>
										</div>
										<div className="dropdown-footer"><Link to={"shop-login"} target="_parent" className="btn btn-primary w-100 btnhover btn-sm" onClick={userLogOut} >Log Out</Link></div>
									</Dropdown.Menu>
								</Dropdown></> : <>
								{/* <Link to={"shop-login"} className="nav-link">
							 			<svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000"><path d="M0 0h24v24H0V0z" fill="none" /><path d="M16.5 3c-1.74 0-3.41.81-4.5 2.09C10.91 3.81 9.24 3 7.5 3 4.42 3 2 5.42 2 8.5c0 3.78 3.4 6.86 8.55 11.54L12 21.35l1.45-1.32C18.6 15.36 22 12.28 22 8.5 22 5.42 19.58 3 16.5 3zm-4.4 15.55l-.1.1-.1-.1C7.14 14.24 4 11.39 4 8.5 4 6.5 5.5 5 7.5 5c1.54 0 3.04.99 3.57 2.36h1.87C13.46 5.99 14.96 5 16.5 5c2 0 3.5 1.5 3.5 3.5 0 2.89-3.14 5.74-7.9 10.05z" /></svg>

							 		</Link>
							 		&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
									<Link to={"shop-login"} className="nav-link">
										<svg xmlns="http://www.w3.org/2000/svg" onClick={headeCartShow} height="24px" viewBox="0 0 24 24" width="24px" fill="#000000"><path d="M0 0h24v24H0V0z" fill="none" /><path d="M15.55 13c.75 0 1.41-.41 1.75-1.03l3.58-6.49c.37-.66-.11-1.48-.87-1.48H5.21l-.94-2H1v2h2l3.6 7.59-1.35 2.44C4.52 15.37 5.48 17 7 17h12v-2H7l1.1-2h7.45zM6.16 6h12.15l-2.76 5H8.53L6.16 6zM7 18c-1.1 0-1.99.9-1.99 2S5.9 22 7 22s2-.9 2-2-.9-2-2-2zm10 0c-1.1 0-1.99.9-1.99 2s.89 2 1.99 2 2-.9 2-2-.9-2-2-2z" /></svg>

							 		</Link> */}
								&nbsp; &nbsp; &nbsp;
								<Dropdown as="li" className="nav-item dropdown profile-dropdown  ms-4 mobileView" id='drpLogin' >
									<div className="dropdown-footer">
										<Link to={"shop-login"} target="_parent" className="btn btn-primary w-100 btnhover btn-sm" >Login</Link>
									</div>
								</Dropdown>
							</>}
							<div className="dz-social-icon">
								<ul> 
									<li><a className="fab fa-facebook-f" target="_blank" rel="noreferrer" href="#"></a></li>									 
									<li><a className="fab fa-linkedin-in" target="_blank" rel="noreferrer" href="#"></a></li>
									<li><a className="fab fa-instagram" target="_blank" rel="noreferrer" href="#"></a></li>
								</ul>
							</div>
						</div>
					</div>
					<Marquee />
				</div>
			</div> 
		</header>

		
	)
}
export default Header;